import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllReviews } from '../../redux/Slices/ReviewsSlice'
import { useParams } from 'react-router-dom'

const UseReviewItem = ({ IsLogin, item }) => {
    const limit = 5;
    let { id } = useParams()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [Pageloading, setPageloading] = useState(true)
    const [allusersLoading, setAllusersLoading] = useState(true)
    const [userChecked, setUserChecked] = useState(false)
    const [AllUsers, setAllUsers] = useState([])
    const [numberOfPages, setNumberOfPages] = useState("")
    const [UserLoginId, setUserLoginId] = useState("")
    const [ReviewUserId, setReviewUserId] = useState("")
    const [reviewData, setReviewData] = useState("")
    const [reviewRating, setReviewRating] = useState("")
    const { AllReviews } = useSelector(state => state.ReviewsReducer)

    // handle get all reviews
    const handleGetAllReview = async () => {
        setLoading(true)
        await dispatch(getAllReviews({ prodId: id, page: 1, limit: limit }))
        setLoading(false)
    }

    // handle get all review to get all users
    const handleAllusers = async () => {
        setAllusersLoading(true)
        await dispatch(getAllReviews({ prodId: id }))
        setAllusersLoading(false)

    }
    // run the handle get all review
    useEffect(() => {
        handleGetAllReview()
        handleAllusers()
    }, [])

    // handle get all users request response 
    useEffect(() => {
        if (allusersLoading === false) {
            if (AllReviews && AllReviews.data.data){
                setAllUsers(AllReviews.data.data.map((item)=>item.user._id))
            }
        }
    }, [allusersLoading])
    
    // handle get all reviews request response
    useEffect(() => {
        if (loading === false) {
            if (AllReviews && AllReviews.data) {
                setReviewData(AllReviews.data.data)
                setNumberOfPages(AllReviews.data.paginationResult.numberOfPages)
                setReviewUserId(AllReviews.data.data.map((item) => item.user._id))
            }
        }
    }, [loading])

    // to get the rating average
    useEffect(() => {
        setReviewRating(item.ratingsAverage)
    }, [item])


    // handle on press pagination
    const onPress = async (page) => {
        setPageloading(true)
        await dispatch(getAllReviews({ prodId: id, page: page, limit: limit }))
        setPageloading(false)
    }

    // handle pagination request response
    useEffect(() => {
        if (Pageloading === false) {
            setReviewData(AllReviews.data.data)
            setNumberOfPages(AllReviews.data.paginationResult.numberOfPages)
            setReviewUserId(AllReviews.data.data.map((item) => item.user._id))
        }
    }, [Pageloading])

    // handleGetUserLoggedID
    const handleGetUserLoggedId = () => {
        if (IsLogin) {
            setUserLoginId(IsLogin._id)
        }
    }

    // run the handle get all user logged id
    useEffect(() => {
        handleGetUserLoggedId()
    }, [IsLogin])

    // handle check if user logged id === user review id
    useEffect(() => {
        if (AllUsers.includes(UserLoginId)) {
            setUserChecked(true)
        } else {
            setUserChecked(false)
        }
    }, [UserLoginId, AllUsers])

    return [reviewData, onPress, UserLoginId, ReviewUserId, reviewRating, numberOfPages, userChecked]
}

export default UseReviewItem
